import { combineReducers } from 'redux';

import { reducer as uploadsReducer } from './uploads/reducer';

export const reducer = combineReducers({
	uploads: uploadsReducer,
});
